module.exports = __webpack_public_path__ + "static/media/dots8.af9ad7ce.png";